import { Spinner } from '@fluentui/react-components';
import { CheckmarkFilled } from '@fluentui/react-icons';
import React from 'react';

type ILoadingState = 'initial' | 'loading' | 'loaded';

const useRequestButton = () => {
  const [loadingState, setLoadingState] = React.useState<ILoadingState>('initial');

  const buttonIcon =
    loadingState === 'loading' ? <Spinner size='tiny' /> : loadingState === 'loaded' ? <CheckmarkFilled /> : null;

  return { buttonIcon, loadingState, setLoadingState };
};

export default useRequestButton;
